import React from 'react';
import { CheckIcon, FlameIcon, GlobeIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { IMAGES } from '../../data/links';
import { offerIncludes } from '../../data/lists';
const SPOTS_LEFT = 7;
const CLAIMED_PERCENT = 93;
export function Offer() {
  return <section id="offer" className="bg-forest px-3 py-16 sm:px-4 sm:py-20" data-id="element-234" data-mp="357nhlnb9toln">
      <div className="mx-auto max-w-3xl" data-id="element-235" data-mp="3a4nog0fy2vdt">
        <div className="text-center" data-id="element-236" data-mp="3a3mb1pbghwsx">
          <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-cream/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-blush" data-id="element-237" data-mp="3f3qh0leqn94w">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-238" data-mp="3jxmelmr3atzj" /> Special launch offer
          </p>
          <h2 className="mt-4 font-serif text-[30px] font-bold leading-tight text-cream sm:text-5xl" data-id="element-239" data-mp="3nyod21d6n20g">
            Here's everything you'll receive today
          </h2>
        </div>

        <img src={IMAGES.mainMockup} alt="Everything included in the offer" className="mx-auto mt-6 w-full max-w-xl" data-id="element-240" data-mp="1pwwvnzdlca1" />

        <div className="mt-4 rounded-3xl bg-paper p-5 text-ink shadow-2xl sm:p-8" data-id="element-241" data-mp="1kj3xhq2gz7yw">
          <dl className="divide-y divide-sand" data-id="element-242" data-mp="1foht46ut2fob">
            <div className="flex items-center justify-between gap-4 pb-4" data-id="element-243" data-mp="1bk0boebx4egp">
              <dt data-id="element-244" data-mp="16lys7sakyd4p">
                <span className="block font-bold text-forest" data-id="element-245" data-mp="16mgx1dbb5zo8">Reflexology 21-Day Practice Method™</span>
                <span className="text-sm text-muted" data-id="element-246" data-mp="23c7rxdnihouk">6 premium volumes</span>
              </dt>
              <dd className="shrink-0 font-bold text-muted line-through" data-id="element-247" data-mp="1za4cyf1mw24j">$97</dd>
            </div>
            <div className="flex items-center justify-between gap-4 py-4" data-id="element-248" data-mp="1uiuqfnbdtewv">
              <dt data-id="element-249" data-mp="1pkkx7i97wodw">
                <span className="block font-bold text-forest" data-id="element-250" data-mp="1pl2wknr6fiq1">5 Exclusive Bonuses</span>
                <span className="text-sm text-muted" data-id="element-251" data-mp="2mzp0zccn9pko">Study cards, protocol, guide, planner, checklists</span>
              </dt>
              <dd className="shrink-0 font-bold text-muted line-through" data-id="element-252" data-mp="2i876n754mn8o">$147</dd>
            </div>
            <div className="flex items-center justify-between gap-4 pt-4" data-id="element-253" data-mp="316iiahxu8ifg">
              <dt className="text-sm font-bold uppercase tracking-wider text-ink" data-id="element-254" data-mp="3653jajkwz64y">Total reference value</dt>
              <dd className="shrink-0 text-xl font-extrabold text-rose line-through" data-id="element-255" data-mp="2sdyru4rp9k5p">$244</dd>
            </div>
          </dl>

          <div className="mt-6 rounded-2xl bg-cream px-4 py-6 text-center" data-id="element-256" data-mp="2wdfuyrjnm57p">
            <p className="text-base text-muted" data-id="element-257" data-mp="2iepxvbwu45jc">But today, you don't pay $244.</p>
            <p className="mt-2 text-xs font-extrabold uppercase tracking-[0.16em] text-forest" data-id="element-258" data-mp="2nelswlnk0mmr">Get everything for just</p>
            <p className="font-serif text-[84px] font-extrabold leading-none text-forest sm:text-[104px]" data-id="element-259" data-mp="29fcqcos9tr19">$27</p>
            <p className="text-sm font-bold uppercase tracking-wider text-ink" data-id="element-260" data-mp="2dgo704t631xb">USD · One-time payment</p>
            <p className="mx-auto mt-4 flex max-w-sm items-start justify-center gap-2 text-left text-sm text-muted" data-id="element-261" data-mp="7ng3wk4kewrp">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-262" data-mp="bmffuooprtsn" />
              Your local currency is converted automatically at checkout.
            </p>
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-x-3 gap-y-2.5" data-id="element-263" data-mp="1s6tjt1a2djh8">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink" data-id="element-264" data-mp="25y87vmitwav5">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-265" data-mp="213u7f5pb7djm" />
                {item}
              </li>)}
          </ul>

          <div className="mt-7 rounded-2xl border-2 border-rose/25 bg-blush/50 p-4" data-id="element-266" data-mp="2av6znyf0s5q6">
            <div className="flex items-center justify-between gap-2 text-sm font-extrabold" data-id="element-267" data-mp="2oupujpitlkkj">
              <span className="flex items-center gap-1.5 text-rose" data-id="element-268" data-mp="2jxg72fezrizc">
                <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-269" data-mp="ugoxna6tz7n3" />
                Only {SPOTS_LEFT} spots left
              </span>
              <span className="text-ink" data-id="element-270" data-mp="pjoqevy8vyue">{CLAIMED_PERCENT}% claimed</span>
            </div>
            <div className="mt-2 h-3.5 overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-271" data-mp="rw0npe5r5olf">
              <div className="h-full rounded-full bg-rose" style={{
              width: `${CLAIMED_PERCENT}%`
            }} data-id="element-272" data-mp="15v8no99qp0qo" />
            </div>
            <p className="mt-2 text-[13px] leading-snug text-ink/80" data-id="element-273" data-mp="8amessbhkxdr">
              {SPOTS_LEFT} spots remain at the $27 promotional price. When they're gone, the price goes back up.
            </p>
          </div>

          <div className="mt-7" data-id="element-274" data-mp="i55zw5cuygxv">
            <CTAButton label="Yes! I want Reflexology 21-Day Practice Method™" note="One-time payment of $27 · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-275" data-mp="my7gchspqojk" />
            <Countdown data-id="element-276" data-mp="3qm0t0t3usmyr" />
            <p className="mt-5 text-center text-sm font-bold uppercase tracking-wide text-forest" data-id="element-277" data-mp="3ql7vmiqsb9ta">
              Start your 21-day reflexology practice today.
            </p>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-base leading-relaxed text-cream/85" data-id="element-278" data-mp="3e4q1ch5qwsza">
          For $27, you get a complete 21-day system designed to help you create a more structured reflexology study and practice
          routine.
        </p>
      </div>
    </section>;
}